export enum LastMileStatusEnum {
  DELIVERY_IN_PROGRESS = "DELIVERY_IN_PROGRESS",
  DELIVERY_REFUSED = "DELIVERY_REFUSED",
  DELIVERY_NOT_POSSIBLE = "DELIVERY_NOT_POSSIBLE",
  RETURNED = "RETURNED",
  CLOSED = "CLOSED",
  UNLOADED = "UNLOADED"
}
